var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.holderNotification)?_c('notification',{attrs:{"message":_vm.holderNotification.message,"confirm":_vm.holderNotification.confirm,"type":_vm.holderNotification.type},on:{"destroy":_vm.destroyNotification}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }